<!--
* @description:
* @fileName shopManage.vue
* @author hvv
* @date 2022/01/13 15:21:21
!-->
<template>
  <div>
    <vab-query-form style="padding-top: 20px">
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="客户姓名">
            <el-input v-model="queryForm.name" placeholder="请输入客户姓名" />
          </el-form-item>
          <el-form-item label="客户手机号" style="margin: 0 10px 10px 10px !important">
            <el-input v-model="queryForm.phone" placeholder="请输入客户手机号" />
          </el-form-item>

          <el-form-item label="客户身份">
            <el-select v-model="queryForm.level" class="m-2" placeholder="请选择客户身份">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="状态">
            <el-select
              v-model="queryForm.status"
              class="m-2"
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item> -->

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
            <!-- <el-button :icon="Search" type="primary" @click="_export">
              导出
            </el-button> -->
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <div style="padding-left: 10px">
      <el-tabs v-model="queryForm.status" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="待审核" name="PENDING_REVIEW" />
        <el-tab-pane label="审核成功" name="ACCEPT" />
        <el-tab-pane label="审核不通过" name="REFUSE" />
      </el-tabs>

      <el-table v-loading="listLoading" border :data="list">
        <el-table-column label="客户姓名" prop="name" show-overflow-tooltip />
        <el-table-column label="客户手机号" prop="phone" show-overflow-tooltip />
        <el-table-column label="客户身份">
          <template #default="{ row }">
            <span v-if="row.level == 'DIAMOND'">钻石</span>
            <span v-else>翡翠</span>
          </template>
        </el-table-column>
        <el-table-column label="公司信息" prop="company" show-overflow-tooltip />
        <el-table-column label="职位" prop="position" show-overflow-tooltip />
        <el-table-column label="出发地">
          <template #default="{ row }">
            <span v-if="row.country == '中国'">{{ row.country }}-{{ row.province }}-{{ row.city }}</span>
            <span v-else>{{ row.country }}</span>
          </template>
        </el-table-column>
        <el-table-column label="杭州目的地" prop="targetArea" show-overflow-tooltip />
        <el-table-column label="来杭目的" prop="target" show-overflow-tooltip />

        <el-table-column label="审核状态" prop="status">
          <template #default="{ row }">
            <el-tag v-if="row.status == 'ACCEPT'" type="success">审核通过</el-tag>
            <el-tag v-if="row.status == 'REFUSE'" type="danger">审核不通过</el-tag>
            <el-tag v-if="row.status == 'PENDING_REVIEW'" type="warning">待审核</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="提交时间" prop="reviewTime">
          <template #default="{ row }">
            <span>{{ handleDate(row.createTime) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" show-overflow-tooltip width="185">
          <template #default="{ row }">
            <el-button v-if="queryForm.status == 'PENDING_REVIEW'" type="primary" @click="handleEdit(row)">
              <vab-icon icon="edit-2-line" />
              去审核
            </el-button>
            <el-button
              v-if="queryForm.status == 'ACCEPT' || queryForm.status == 'REFUSE'"
              type="primary"
              @click="handleEdit(row)"
            >
              <vab-icon icon="edit-2-line" />
              更改
            </el-button>
            <!-- <el-button type="danger" @click="handleDelete(row)">
            <vab-icon icon="delete-bin-6-line" />
            删除
          </el-button> -->
          </template>
        </el-table-column>
        <template #empty>
          <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
          <el-empty class="vab-data-empty" description="暂无数据" />
        </template>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.pageNumber"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <edit ref="editRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import { defineComponent, defineAsyncComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getPassList, exportPassList } from '@/api/passApply'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'TicketList',
    components: {
      Edit: defineAsyncComponent(() => import('./components/editHost')),
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        queryForm: {
          name: '',
          pageNum: 1,
          pageSize: 20,
          phone: '',
          level: '',
          status: 'PENDING_REVIEW',
        },
        total: 0,
        shopList: [],
        listLoading: false,
        list: [],
        layout: 'prev, pager, next',
        editRef: null,
        typeOptions: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '翡翠',
            value: 'EMERALD',
          },
          {
            label: '钻石',
            value: 'DIAMOND',
          },
        ],
        statusOption: [
          {
            label: '待审核',
            value: 'PENDING_REVIEW',
          },
          {
            label: '审核通过',
            value: 'ACCEPT',
          },
          {
            label: '审核不通过',
            value: 'REFUSE',
          },
        ],
      })

      const handleEdit = (row) => {
        state.editRef.showEdit(row)
      }
      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getPassList(state.queryForm)
        state.list = data.data
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        queryData()
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleClick = (val) => {
        console.log(val)
        queryData()
      }

      const _export = async () => {
        const { data } = await exportPassList(state.queryForm)
        console.log(data, '1123123')
        window.open(data.fileUrl)
      }

      onMounted(() => {
        queryData()
      })

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDate,
        handleClick,
        _export,
        Delete,
        Search,
        Plus,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
